import { Dropdown } from '@landlord-tech/ui-kit-opp/dist/components/Dropdown';
import styled from 'styled-components';
import { TDropDownProp } from './Dropdown.types';

const SDropdown = styled(Dropdown)<TDropDownProp>``;

export { SDropdown };
